<template>
  <transition name="el-zoom-in-top">
    <div class="content-wrapper">
      <section class="content-header">
        <ol class="breadcrumb">
          <li>
            <router-link to="/">
              <i class="ti-home"></i>
            </router-link>
          </li>
          <li>
            <router-link :to="{name:'customers'}">Customers</router-link>
          </li>
          <li class="active">
            <a href="#">Edit Customer</a>
          </li>
        </ol>
      </section>
      <!-- Main content -->
      <section class="content customers-content">
        <div class="box">
          <div class="box-body">
            <el-form
              :model="customer"
              :rules="rules"
              ref="customer"
              label-width="120px"
              label-position="top"
            >
              <el-form-item label="Name" prop="name">
                <el-input v-model="customer.name"></el-input>
              </el-form-item>
              <el-form-item label="Api key" prop="customerSecretKey">
                {{customer.customerSecretKey}}
                <el-button @click="generateKey" :disabled="!!customer.customerSecretKey">Generate</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitForm('customer')">Save</el-button>
                <el-button @click="resetForm('customer')">Reset</el-button>
              </el-form-item>
            </el-form>
            <hr>
          </div>
          <!-- /.box-body -->
        </div>
      </section>
      <!-- /.content -->
    </div>
  </transition>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "customer-edit",
  props: {
    id: {
      required: true
    }
  },
  data() {
    return {
      loading: false,
      customer: {
        name: "",
        customerSecretKey: ""
      },
      rules: {
        name: [
          {
            required: true,
            message: "Please input customer name",
            trigger: "blur"
          },
          { min: 3, message: "Length should be more then 3", trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    ...mapGetters("customers", ["list"])
  },
  mounted() {
    this.loading = true;
    this.getCustomer(this.id)
      .then(resp => {
        this.loading = false;
        this.customer = resp.data;
      })
      .catch(_ => {
        this.loading = false;
        this.$router.push({ name: "404" });
      });
  },
  methods: {
    ...mapActions("customers", [
      "saveCustomer",
      "getCustomer",
      "addCustomerSecretKey"
    ]),
    resetForm(formName) {
      this.$router.push({ name: "customers" });
    },
    generateKey() {
      this.loading = true;
      this.addCustomerSecretKey({ id: this.id })
        .then(resp => {
          this.customer = resp.data;
          this.loading = false;
        })
        .catch(_ => {
          this.loading = false;
        });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.saveCustomer({ id: this.id, customer: this.customer }).then(_ =>
            this.$router.push({ name: "customers" })
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// Edit.vue?2725d66b